"use client";
import Image from "next/image";
import HomLine from "../../public/images/home_line.png";
import "../globals.css";
import React, { use } from "react";
import { usePathname } from "next/navigation";
import DataDisplay_Knowledge_Layout1 from "./DataDisplayTabs/Knowledge/Layout1";
import DataDisplay_Invention_Layout1 from "./DataDisplayTabs/Invention/Layout1";

interface Picture {
  data: {
    id: string;
    attributes: {
      url: string;
      name: string;
      alternativeText: string;
    };
  };
}

interface Card {
  title: string;
  text: string;
  href: string;
  hrefText: string;
  image: Picture;
}

interface DataDisplayProps {
  data: {
    id: number;
    title: string;
    subtitle: string;
    Card: Card[];
    isLive: boolean;
    useH1Tag?: boolean;
  };
}

export default function DataDisplay({ data }: DataDisplayProps) {
  if (!data.isLive)
    return;
  const pathname = usePathname();
  const isKnowledge = pathname === "/knowledge";
  const isInvention = pathname === "/invention";

  return (
    isKnowledge ? <DataDisplay_Knowledge_Layout1 data={data} />
      :
      <DataDisplay_Invention_Layout1 data={data} />
  );
}
